import { render, staticRenderFns } from "./ImportantLink.vue?vue&type=template&id=072ed0a8&scoped=true&"
import script from "./ImportantLink.vue?vue&type=script&lang=js&"
export * from "./ImportantLink.vue?vue&type=script&lang=js&"
import style0 from "./ImportantLink.vue?vue&type=style&index=0&id=072ed0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072ed0a8",
  null
  
)

export default component.exports